"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var search_results_component_1 = require("src/app/Adv/search-results/search-results.component");
var moment = require("moment");
var service_service_1 = require("../../Services/service.service");
var AdvSmallComponent = /** @class */ (function () {
    function AdvSmallComponent(service) {
        this.service = service;
        this.Title = "";
        this.Tag = "";
        this.ImageUrl = "";
        this.Location = "";
        this.Description = "";
        this.Expired = false;
        this.IsPremium = false;
        this.PremiumText = "";
        this.IsThirdParty = false;
        this.AdvShouldBeReposted = new core_1.EventEmitter();
        this.displayModeType = search_results_component_1.displayModeType;
    }
    Object.defineProperty(AdvSmallComponent.prototype, "advDate", {
        get: function () {
            return this.Date.format("MM/DD/YYYY hh:mm A");
        },
        enumerable: true,
        configurable: true
    });
    AdvSmallComponent.prototype.ngOnInit = function () {
    };
    AdvSmallComponent.prototype.fireRepost = function (event) {
        event.stopPropagation();
        this.AdvShouldBeReposted.emit();
        return false;
    };
    return AdvSmallComponent;
}());
exports.AdvSmallComponent = AdvSmallComponent;
